module.exports = __webpack_public_path__ + "img/icon-15.a35914d2.png";